export class TenantWebsite {
  /**
   * @returns Retorna o websiteId encontrado no pathname ou 'unknown' se não for encontrado.
   */
  public static getIdFromPathname(pathname: string): string {
    const match = pathname.match(/\/website\/([^/]+)/);
    return match ? match[1] : 'unknown';
  }
}
